import src from "IMAGE";
export default { src, width: 1536, height: 1164, blurWidth: 0, blurHeight: 0};
